import PropTypes from 'react-proptypes';
import ToolLogoSvg from 'images/maxmortgage/logo.svg';

const TABS = {
  RESULT: 'RESULT',
  APPOINTMENT: 'APPOINTMENT',
  SENT: 'SENT',
};

let pages = ['landing', 'partner', 'expenses', 'energy-label', 'final'];

const loanpart = {
  mortgageType: null,
  startDate: '',
  currentDebt: null,
};

export default {
  app: 'maxmortgage',
  logo: ToolLogoSvg,
  pages,
  syncing: false,
  broken: false,
  recalculating: null,
  settings: null,
  tab: TABS.RESULT,
  input: {
    // landing / applicant
    applicant_dob: '',
    applicant_income: null,
    applicant_income_period: 'monthly',
    applicant_holiday_bonus: true,
    applicant_13th_month_salary: false,
    applicant_is_entrepreneur: false,
    applicant_is_entrepreneur_for_three_years: true,
    applicant_entrepreneur_prognoses_current_year: null,
    applicant_entrepreneur_fiscal_profit_last_year: null,
    applicant_entrepreneur_fiscal_profit_two_years_ago: null,
    applicant_entrepreneur_fiscal_profit_three_years_ago: null,
    applicant_pension_income: null,
    applicant_pension_income_period: 'yearly',
    // partner
    applicant_has_partner: false,
    partner_dob: '',
    partner_income: null,
    partner_income_period: 'monthly',
    partner_holiday_bonus: true,
    partner_13th_month_salary: false,
    partner_is_entrepreneur: false,
    partner_is_entrepreneur_for_three_years: true,
    partner_entrepreneur_prognoses_current_year: null,
    partner_entrepreneur_fiscal_profit_last_year: null,
    partner_entrepreneur_fiscal_profit_two_years_ago: null,
    partner_entrepreneur_fiscal_profit_three_years_ago: null,
    partner_pension_income: null,
    partner_pension_income_period: 'yearly',
    // mortgage
    applicant_has_mortgage: false,
    loanparts: [loanpart],
    current_house_value: null,
    // expenses
    has_student_loan: false,
    student_loan_monthly_payment: null,
    has_partner_student_loan: null,
    partner_student_loan_monthly_payment: null,
    has_total_credits: false,
    total_credits: null,
    has_partner_total_credits: false,
    partner_total_credits: null,
    has_partner_alimony: false,
    partner_alimony: null,
    has_partner_partner_alimony: false,
    partner_partner_alimony: null,
    has_ground_rent: false,
    ground_rent: null,
    private_lease: null,
    has_private_lease: false,
    private_lease_duration: null,
    has_partner_private_lease: false,
    partner_private_lease: null,
    partner_private_lease_duration: null,
    //energy label
    energy_label: 'E',

    //lead information
    email: null,
    phone_number: null,

    // extra options
    energy_saving_measures: false,
    mortgage_interest_deduction: true,
    new_regulations: false,
    fixed_rate_term: 10,
  },
  output: {
    errors: {},
  },
};

// No objects or Arrays included in whitelist at the moment
// Objects and Arrays cannot be send in their current format in the url
// If they need to be send then get the primitive value that is needed or stringify first
const whitelistUrlParams = [
  'applicant_dob',
  'applicant_income',
  'applicant_income_period',
  'applicant_holiday_bonus',
  'applicant_13th_month_salary',
  'applicant_is_entrepreneur',
  'applicant_is_entrepreneur_for_three_years',
  'applicant_entrepreneur_prognoses_current_year',
  'applicant_entrepreneur_fiscal_profit_last_year',
  'applicant_entrepreneur_fiscal_profit_two_years_ago',
  'applicant_entrepreneur_fiscal_profit_three_years_ago',
  'applicant_pension_income',
  'applicant_pension_income_period',
  'applicant_has_partner',
  'partner_dob',
  'partner_income',
  'partner_income_period',
  'partner_holiday_bonus',
  'partner_13th_month_salary',
  'partner_is_entrepreneur',
  'partner_is_entrepreneur_for_three_years',
  'partner_entrepreneur_prognoses_current_year',
  'partner_entrepreneur_fiscal_profit_last_year',
  'partner_entrepreneur_fiscal_profit_two_years_ago',
  'partner_entrepreneur_fiscal_profit_three_years_ago',
  'partner_pension_income',
  'partner_pension_income_period',
  'applicant_has_mortgage',
  'current_house_value',
  'has_student_loan',
  'student_loan_monthly_payment',
  'has_partner_student_loan',
  'partner_student_loan_monthly_payment',
  'has_total_credits',
  'has_partner_total_credits',
  'total_credits',
  'partner_total_credits',
  'has_partner_alimony',
  'partner_alimony',
  'has_partner_partner_alimony',
  'partner_partner_alimony',
  'has_ground_rent',
  'ground_rent',
  'has_private_lease',
  'private_lease',
  'private_lease_duration',
  'has_partner_private_lease',
  'partner_private_lease',
  'partner_private_lease_duration',

  //lead information
  'email',
  'phone_number',

  'energy_saving_measures',
  'mortgage_interest_deduction',
  'new_regulations',
  'fixed_rate_term',
  'ground_rent',
  'has_ground_rent',
  'applicant_aow_income',
  'partner_aow_income',
  'max_mortgage',
  'frt',
  'nhg',
];

// to prevent duplicate keys in the url params
const blacklistOutputUrlParams = [
  'applicant_income',
  'applicant_aow_income',
  'partner_income',
  'partner_aow_income',
  'show_applicant_pension_income',
  'show_partner_pension_income',
];

const { string, number, bool, shape, arrayOf } = PropTypes;

const shapeSettings = shape({
  leadButtonUrl: string,
  leadButtonText: string,
  showLeadButton: bool,
  leadFormHeader: string,
  leadAddressInformation: bool,
  leadFormText: string,
  enablePdf: bool,
  enableHypotheekbondLogo: bool,
  energySavingMeasuresSwitch: bool,
  showLeadInformationSwitch: bool,
  hideProvidersInResult: bool,
  newRegulationsSwitch: bool,
  nonDeductableAmountSwitch: bool,
  regulations: shape({
    nhg_max_loan: number,
  }),
});


const shapeInput = shape({
  applicant_dob: string,
  applicant_income: number,
  applicant_income_period: string,
  applicant_holiday_bonus: bool,
  applicant_13th_month_salary: bool,
  applicant_is_entrepreneur: bool,
  applicant_is_entrepreneur_for_three_years: bool,
  applicant_entrepreneur_prognoses_current_year: number,
  applicant_entrepreneur_fiscal_profit_last_year: number,
  applicant_entrepreneur_fiscal_profit_two_years_ago: number,
  applicant_entrepreneur_fiscal_profit_three_years_ago: number,
  applicant_has_partner: bool,
  partner_dob: string,
  partner_income: number,
  partner_income_period: string,
  partner_holiday_bonus: bool,
  partner_13th_month_salary: bool,
  partner_is_entrepreneur: bool,
  partner_is_entrepreneur_for_three_years: bool,
  partner_entrepreneur_prognoses_current_year: number,
  partner_entrepreneur_fiscal_profit_last_year: number,
  partner_entrepreneur_fiscal_profit_two_years_ago: number,
  partner_entrepreneur_fiscal_profit_three_years_ago: number,
  total_credits: number,
  partner_alimony: number,
  ground_rent: number,
  info_box: string,
  applicant_pension_income_period: string,
  partner_pension_income_period: string,
});

const shapeOutput = shape({
  frt_data: arrayOf(shape({})),
  show_applicant_pension_income: bool,
  show_partner_pension_income: bool,
  errors: shape({}),
  applicant_income: number,
  partner_income: number,
});

export { TABS, loanpart, whitelistUrlParams, blacklistOutputUrlParams, shapeSettings, shapeInput, shapeOutput };
